import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { dataTableSectionSx } from "common/Components/DataTable/DataTable.styles";
import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeRadius } from "styles/appThemeTokens";

const uiFont = appThemeFonts.family.ui;
const numericFont = appThemeFonts.family.numeric;

export const UsersListLayout = styled(Box)({
  ...dataTableSectionSx,
  fontFamily: uiFont,
});

export const ResultsBar = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "14px",
  flexWrap: "wrap",
  rowGap: "8px",
  marginBottom: "12px",
});

export const ResultsSummary = styled(Typography)({
  fontFamily: numericFont,
  fontSize: "13px",
  color: appThemeColors.text.muted,
  margin: 0,
  fontVariantNumeric: "tabular-nums",
});

export const ClearFiltersButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "$active",
})(({ $active }) => ({
  height: 34,
  padding: "0 15px",
  background: appThemeColors.background.paper,
  border: `1px solid ${
    $active ? appThemeColors.border.strong : appThemeColors.border.default
  }`,
  borderRadius: appThemeRadius.pill,
  color: $active ? appThemeColors.text.primary : appThemeColors.text.faintLight,
  fontSize: "12.5px",
  fontWeight: 500,
  cursor: $active ? "pointer" : "default",
  fontFamily: uiFont,
  "&:hover": $active
    ? {
        backgroundColor: appThemeColors.background.kbd,
        borderColor: appThemeColors.text.lightBlue,
      }
    : undefined,
  "&:disabled": {
    cursor: "default",
  },
}));

export const AccessActionButton = styled("button", {
  shouldForwardProp: (prop) => prop !== "$tone",
})(({ $tone }) => ({
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  cursor: "pointer",
  textTransform: "none",
  fontSize: "12.5px",
  fontWeight: 600,
  textDecoration: "underline",
  textUnderlineOffset: "2px",
  fontFamily: uiFont,
  color:
    $tone === "danger"
      ? appThemeColors.semantic.danger
      : appThemeColors.text.lightBlue,
  textAlign: "left",
  "&:hover": {
    color:
      $tone === "danger"
        ? appThemeColors.semantic.danger
        : appThemeColors.text.heading,
  },
  "&:disabled": {
    color: appThemeColors.text.faint,
    cursor: "not-allowed",
    textDecoration: "none",
  },
}));

export const CellText = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "13px",
  fontWeight: 400,
  color: appThemeColors.text.primary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const EmailCellText = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "13px",
  fontWeight: 500,
  color: appThemeColors.text.primary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "block",
  lineHeight: 1.35,
});

export const MutedCellText = styled(Typography)({
  fontFamily: uiFont,
  fontSize: "13px",
  fontWeight: 400,
  color: appThemeColors.text.muted,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const MonoCellText = styled(Typography)({
  fontFamily: numericFont,
  fontSize: "12.5px",
  fontWeight: 400,
  color: appThemeColors.text.muted,
  fontVariantNumeric: "tabular-nums",
  whiteSpace: "nowrap",
});
